<template>
  <div class="w-100 d-flex justify-content-center">
    <div class="my-1 card">
      <div class="my-0 py-1 card-header text-info">
        <h4 class="my-0 py-1">Tasks for the selected services</h4>
      </div>
      <div class="card-body">
        <b-tabs card class="serviceCard" v-if="isServiceconfig">
          <b-tab
            title="Rate Card"
            active
            class="ratecard"
            v-if="
              (this.$store.getters.selectedIncidentType == 'it-ran-eve' ||
                this.$store.getters.selectedIncidentType == 'it-bus-ema-com' ||
                this.$store.getters.selectedIncidentType == 'it-extortion') &&
              this.$store.getters.selectedCountry != 'ctry-in-le'
            "
          >
            <b-card-text v-if="rateCardDetails">
              <div class="row" style="margin-bottom: 10px">
                <div class="col-sm-6">
                  <!-- <b-form-checkbox
                    v-model="rateCardDetails.hasOptionalTasks"
                    name="checkbox-1"
                    class="float-left"
                    @change="handlehasOptional()"
                  >
                    Has Optional Tasks :
                    {{ rateCardDetails.hasOptionalTasks ? "Yes" : "No" }}
                  </b-form-checkbox> -->
                </div>
                <div class="col-sm-6">
                  <b-button
                    size="sm"
                    @click="addService()"
                    title="Add New Service"
                    variant="info"
                    class="float-right"
                  >
                    <font-awesome-icon :icon="['fas', 'plus']" size="sm" />
                    <b> Add New Service</b>
                  </b-button>
                </div>
              </div>
              <div v-if="!rateCardDetails.hasOptionalTasks">
                <b-table
                  bordered
                  hover
                  :items="rateCardDetails.rateCards"
                  :fields="fields"
                  style="font-size: 12px"
                >
                  <template v-slot:cell(actions)="data">
                    <b-row>
                      <b-button
                        size="sm"
                        :id="data.item.task"
                        @click="editService(data)"
                        :title="'Edit ' + data.item.task"
                        style="margin-right: 3px"
                        variant="outline-info"
                        v-if="
                          data.item.task != 'Sub Total Labor' &&
                          data.item.task !=
                            'Project Management & Administration'
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" />
                      </b-button>
                      <b-button
                        size="sm"
                        @click="confirmDelete(data)"
                        variant="outline-danger"
                        :title="'Delete ' + data.item.task"
                        v-if="data.item.isNewService"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'trash-alt']"
                          size="sm"
                        />
                      </b-button>
                    </b-row>
                  </template>
                  <template slot="custom-foot">
                    <b-tr>
                      <b-td colspan="2"><span class="sr-only"></span></b-td>
                      <b-td colspan="1">Estimated Labor</b-td>
                      <b-td><span class="sr-only"></span></b-td>
                      <b-td>{{ rateCardDetails.estimatedLabor }}</b-td>
                      <b-td
                        rowspan="3"
                        style="vertical-align: middle"
                        class="actionswidth"
                      >
                        <div class="row">
                          <!-- <b-button
                            size="sm"
                            variant="outline-info"
                            title="Edit Estimated Labor and Travel Expenses Cost"
                            @click="editEstimatedLabour(rateCardDetails)"
                          >
                            <font-awesome-icon
                              :icon="['fas', 'pen']"
                              size="sm"
                            />
                          </b-button> -->
                        </div>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td colspan="2"><span class="sr-only"></span></b-td>
                      <b-td colspan="1">Travel Expenses At Cost</b-td>
                      <b-td><span class="sr-only"></span></b-td>
                      <b-td>{{ rateCardDetails.travelExpense }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-td colspan="2"><span class="sr-only"></span></b-td>
                      <b-td colspan="1">Estimated Labor Cost</b-td>
                      <b-td><span class="sr-only"></span></b-td>
                      <b-td>{{ rateCardDetails.totalEstimatedLabor }}</b-td>
                    </b-tr>
                  </template>
                </b-table>
              </div>
              <div v-if="rateCardDetails.hasOptionalTasks">
                <b-table
                  bordered
                  hover
                  :items="rateCardDetails.rateCards"
                  :fields="optionaltaskfields"
                  style="font-size: 12px"
                >
                  <template v-slot:cell(actions)="data">
                    <b-row>
                      <b-button
                        size="sm"
                        :id="data.item.task"
                        @click="editService(data)"
                        :title="'Edit ' + data.item.task"
                        variant="outline-info"
                        style="margin-right: 3px"
                        v-if="
                          data.item.task != 'Sub Total Labor' &&
                          data.item.task !=
                            'Project Management & Administration'
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" />
                      </b-button>
                      <b-button
                        size="sm"
                        @click="confirmDelete(data)"
                        variant="outline-danger"
                        :title="'Delete ' + data.item.task"
                        v-if="data.item.isNewService"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'trash-alt']"
                          size="sm"
                        />
                      </b-button>
                    </b-row>
                  </template>
                  <template slot="custom-foot">
                    <b-tr>
                      <b-td colspan="1"><span class="sr-only"></span></b-td>
                      <b-td colspan="3">Estimated Labor</b-td>
                      <b-td>{{ rateCardDetails.estimatedLabor }}</b-td>
                      <b-td>{{ rateCardDetails.optionalEstimatedLabor }}</b-td>
                      <b-td>{{ rateCardDetails.fullEstimatedLabor }}</b-td>
                      <b-td
                        rowspan="3"
                        style="vertical-align: middle"
                        class="actionswidth"
                      >
                        <div class="row">
                          <!-- <b-button
                            size="sm"
                            variant="outline-info"
                            @click="editEstimatedLabour(rateCardDetails)"
                          >
                            <font-awesome-icon
                              :icon="['fas', 'pen']"
                              size="sm"
                            />
                          </b-button> -->
                        </div>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-td colspan="1"><span class="sr-only"></span></b-td>
                      <b-td colspan="5">Travel Expenses At Cost</b-td>
                      <b-td>{{ rateCardDetails.travelExpense }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-td colspan="1"><span class="sr-only"></span></b-td>
                      <b-td colspan="3">Estimated Labor Cost</b-td>
                      <b-td>{{ rateCardDetails.totalEstimatedLabor }}</b-td>
                      <b-td>{{
                        rateCardDetails.optionalTotalEstimatedLabor
                      }}</b-td>
                      <b-td>{{ rateCardDetails.fullTotalEstimatedLabor }}</b-td>
                    </b-tr>
                  </template>
                </b-table>
              </div>
            </b-card-text>
            <div v-else>
              <div
                class="w-100 mx-0 my-2 px-2 d-block alert alert-warning"
                role="alert"
              >
                <div v-if="errorMsg">{{ errorMsg }}</div>
                <div v-else>
                  No project details found for the selected client to generate
                  RateCard
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab
            title="Service Overview"
            class="sericeCardTitle"
            v-if="
              isServiceconfig &&
              (this.$store.getters.selectedIncidentType == 'it-ran-eve' ||
                this.$store.getters.selectedIncidentType == 'it-bus-ema-com')
            "
          >
            <div
              v-bind:key="service.slug"
              v-for="(service, index) in servicesConfig"
            >
              <b-card-text>
                <div v-if="index == 0">
                  <p>
                    <span class="font-weight-bold text-info">Overview:</span>
                    <small
                      v-if="service.serviceDescription"
                      class="font-weight-light my-1"
                      >{{ service.serviceDescription }}</small
                    >
                    <span>
                      <font-awesome-icon
                        v-if="!editMode && !addovMode"
                        @click="handleAddOverview(service)"
                        class="pl-1 text-info"
                        :icon="['fas', 'plus']"
                      ></font-awesome-icon>
                    </span>
                  </p>
                  <ul>
                    <div
                      v-bind:key="overview.description"
                      v-for="overview in service.DefaultOverviews"
                    >
                      <li>
                        <p>
                          <small
                            v-if="overview.description"
                            class="font-weight-light my-1"
                            >{{ overview.description }}</small
                          >
                          <font-awesome-icon
                            v-if="!editovMode && !addovMode && !editMode"
                            size="sm"
                            class="pl-1 text-info"
                            @click="handleOverviewEdit(overview)"
                            :icon="['fas', 'pen']"
                          ></font-awesome-icon>
                        </p>
                      </li>
                    </div>
                  </ul>
                </div>
                <ul>
                  <div
                    v-for="(overview, index) in service.ServiceOverview.Items"
                    v-bind:key="`overview-${index}`"
                  >
                    <li>
                      <p>
                        <small v-if="overview" class="font-weight-light my-1">{{
                          overview.description
                        }}</small>
                        <font-awesome-icon
                          v-if="!editovMode && !addovMode && !editMode"
                          size="sm"
                          class="pl-1 text-info"
                          @click="handleOverviewEdit(overview)"
                          :icon="['fas', 'pen']"
                        ></font-awesome-icon>
                      </p>
                    </li>
                  </div>
                </ul>
              </b-card-text>
            </div>
          </b-tab>
          <b-tab
            title="Service Tasks & Scopes"
            v-if="
              isServiceconfig &&
              this.$store.getters.selectedSubofferingType != 'stype-fix-bec'
            "
          >
          <div v-if="this.$store.getters.selectedServices == ''">
            <p>
            No services selected for
            <strong>{{ subofferingfilter(selectedSubType) }}</strong> click
            Generate SOW.
          </p>
          </div>
            <div v-bind:key="service.Slug" v-for="service in servicesConfig">
              <b-card-text>
                <div>
                  <h5 class="font-weight-bold">
                    {{
                      service.isOptional
                        ? "OPTIONAL - " + service.serviceTitle
                        : service.serviceTitle
                    }}
                    <font-awesome-icon
                      size="sm"
                      v-bind:key="service.slug"
                      v-if="service.isOptional"
                      title="is optional?"
                      style="cursor: auto"
                      class="d-inline-block ml-2 text-info"
                      v-bind:icon="['fa', 'toggle-on']"
                    ></font-awesome-icon>

                    <font-awesome-icon
                      v-if="!editMode && !addMode"
                      class="pl-1 text-info"
                      @click="handleServiceTSEdit(service)"
                      :icon="['fas', 'pen']"
                    ></font-awesome-icon>
                    <b-badge
                      variant="light"
                      v-if="!editMode && !addMode"
                      @click="handleAdd(service)"
                    >
                      <font-awesome-icon
                        class="pl-1 text-info"
                        :icon="['fas', 'plus']"
                      ></font-awesome-icon>
                      <span>Task</span>
                    </b-badge>
                    <b-badge
                      variant="light"
                      v-if="!editMode && !addMode"
                      @click="handleAddScope(service)"
                    >
                      <font-awesome-icon
                        class="pl-1 text-info"
                        :icon="['fas', 'plus']"
                      ></font-awesome-icon>
                      <span>Scope</span>
                    </b-badge>
                  </h5>
                </div>
                <span class="font-weight-bold text-info">Tasks:</span>
                <ul>
                  <li v-bind:key="task.slug" v-for="task in service.tasks">
                    <div>
                      <p>
                        <small
                          v-if="task.description"
                          class="font-weight-light my-1"
                          :class="{
                            'text-danger': !task.isActive,
                          }"
                          >{{ task.description }}</small
                        >
                        <font-awesome-icon
                          size="sm"
                          v-if="!editMode && !addMode"
                          :class="{
                            'text-danger': !task.isActive,
                            'text-info': task.isActive,
                          }"
                          @click="handleTaskEdit(task)"
                          :icon="['fas', 'pen']"
                        ></font-awesome-icon>
                        <font-awesome-icon
                          size="sm"
                          v-if="!editMode && !addMode"
                          @click="task.isActive = !task.isActive"
                          class="ml-2"
                          :class="{
                            'text-danger': !task.isActive,
                            'text-info': task.isActive,
                          }"
                          :icon="['fas', 'trash-alt']"
                        ></font-awesome-icon>
                      </p>
                    </div>
                    <ul>
                      <li v-bind:key="item.slug" v-for="item in task.items">
                        <p
                          :class="{
                            'text-danger': !item.isActive,
                            'text-info': item.isActive,
                          }"
                        >
                          <small class="font-weight-light my-1">{{
                            item.title
                          }}</small>
                        </p>
                        <p
                          :class="{
                            'text-danger': !item.isActive,
                          }"
                        >
                          <small class="font-weight-light my-1">{{
                            item.description
                          }}</small>
                        </p>
                      </li>
                    </ul>
                  </li>
                </ul>
                <span class="font-weight-bold text-info">Scopes:</span>
                <ul>
                  <li v-bind:key="scope.Slug" v-for="scope in service.scopes">
                    <div>
                      <p>
                        <small
                          v-if="scope.description"
                          class="font-weight-light my-1"
                          :class="{ 'text-danger': scope.shouldBeHidden }"
                          >{{ scope.description }}</small
                        >
                        <font-awesome-icon
                          size="sm"
                          v-if="!editMode && !addMode"
                          :class="{
                            'text-danger': scope.shouldBeHidden,
                            'text-info': !scope.shouldBeHidden,
                          }"
                          @click="handleScopeEdit(scope)"
                          :icon="['fas', 'pen']"
                        ></font-awesome-icon>
                        <font-awesome-icon
                          size="sm"
                          v-if="!editMode && !addMode"
                          @click="scope.shouldBeHidden = !scope.shouldBeHidden"
                          class="ml-2"
                          :class="{
                            'text-danger': scope.shouldBeHidden,
                            'text-info': !scope.shouldBeHidden,
                          }"
                          :icon="['fas', 'trash-alt']"
                        ></font-awesome-icon>
                      </p>
                    </div>
                  </li>
                </ul>
              </b-card-text>
            </div>
          </b-tab>
          <div v-bind:key="service.slug" v-for="service in servicesConfig">
            <div v-if="service.postSections != null">
              <div v-if="service.postSections.length > 0">
                <b-tab title="Other Details">
                  <b-card-text>
                    <ul>
                      <li
                        v-bind:key="postSections.slug"
                        v-for="postSections in service.postSections"
                      >
                        <div v-if="postSections.isActive">
                          <span class="font-weight-bold">
                            {{ postSections.title }}
                            <font-awesome-icon
                              class="pl-1 text-info"
                              @click="
                                handlePostSectionsEdit(postSections, service)
                              "
                              :icon="['fas', 'pen']"
                            ></font-awesome-icon>
                          </span>
                          <div>
                            <p>
                              <small
                                v-if="postSections.description"
                                class="font-weight-light my-1"
                                >{{ postSections.description }}</small
                              >
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul>
                      <li
                        v-bind:key="preSections.slug"
                        v-for="preSections in service.preSections"
                      >
                        <div v-if="preSections.isActive">
                          <span class="font-weight-bold">
                            {{ preSections.title }}
                            <font-awesome-icon
                              class="pl-1 text-info"
                              @click="
                                handlePreSectionsEdit(preSections, service)
                              "
                              :icon="['fas', 'pen']"
                            ></font-awesome-icon>
                          </span>
                          <div>
                            <p>
                              <small
                                v-if="preSections.description"
                                class="font-weight-light my-1"
                                >{{ preSections.description }}</small
                              >
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </b-card-text>
                </b-tab>
              </div>
            </div>
          </div>
        </b-tabs>
        <div v-else>
          <p>
            Present no services configured for
            <strong>{{ subofferingfilter(selectedSubType) }}</strong> click
            Generate SOW.
          </p>
        </div>
        <button class="btn btn-secondary" @click="goback">
          <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon
          >Back
        </button>
        <button
          class="btn btn-info mx-2"
          v-bind:disabled="notnextable"
          @click="gonext"
        >
          Generate SOW
          <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
        </button>
      </div>
    </div>
    <div
      v-if="
        editMode ||
        addMode ||
        addovMode ||
        addscopeMode ||
        editovMode ||
        edittsMode ||
        editpsMode ||
        editprsMode
      "
      class="sidepanel"
    >
      <div class="pl-1 pr-1">
        <div v-if="!addovMode && !editovMode && !editpsMode && !editprsMode">
          <div class="form-group" v-if="!editMode || edittsMode">
            <label for="txtTitle" class="font-weight-bold text-white"
              >title</label
            >
            <input
              type="text"
              class="form-control"
              id="txtTitle"
              v-model="editItem.title"
            />
            <small class="text-white form-text">{{ editItem.title }}</small>
          </div>
          <div class="form-group" v-if="!edittsMode">
            <label
              for="exampleInputPassword1"
              class="font-weight-bold text-white"
              >description</label
            >
            <textarea
              class="form-control"
              v-model="editItem.description"
            ></textarea>
            <small class="text-white form-text">{{
              editItem.description
            }}</small>
          </div>
        </div>
        <div v-else-if="editpsMode">
          <div class="form-group">
            <label for="txtTitle" class="font-weight-bold text-white"
              >title</label
            >
            <input
              type="text"
              class="form-control"
              id="txtTitle"
              v-model="editpostSections.title"
            />
            <small class="text-white form-text">{{
              editpostSections.title
            }}</small>
          </div>
          <div class="form-group">
            <label
              for="exampleInputPassword1"
              class="font-weight-bold text-white"
              >description</label
            >
            <textarea
              class="form-control"
              v-model="editpostSections.description"
            ></textarea>
            <small class="text-white form-text">{{
              editpostSections.description
            }}</small>
          </div>
        </div>
        <div v-else-if="editprsMode">
          <div class="form-group">
            <label for="txtTitle" class="font-weight-bold text-white"
              >title</label
            >
            <input
              type="text"
              class="form-control"
              id="txtTitle"
              v-model="editpreSections.title"
            />
            <small class="text-white form-text">{{
              editpreSections.title
            }}</small>
          </div>
          <div class="form-group">
            <label
              for="exampleInputPassword1"
              class="font-weight-bold text-white"
              >description</label
            >
            <textarea
              class="form-control"
              v-model="editpreSections.description"
            ></textarea>
            <small class="text-white form-text">{{
              editpreSections.description
            }}</small>
          </div>
        </div>

        <div class="serviceoverview" v-else>
          <div class="form-group">
            <label
              for="exampleInputPassword1"
              class="font-weight-bold text-white"
              >Overview</label
            >
            <input
              type="text"
              class="form-control"
              id="txtTitle"
              v-model="editItem.Overview"
            />
            <small class="text-white form-text">{{ editItem.Overview }}</small>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-dark"
          @click="
            editMode = false;
            addMode = false;
            addovMode = false;
            editovMode = false;
            edittsMode = false;
            editpsMode = false;
            editprsMode = false;
            addscopeMode = false;
            editItem.title = '';
            editItem.description = '';
            postSections.title = '';
            postSections.description = '';
          "
        >
          Cancel
        </button>
        <button type="button" class="ml-2 btn btn-info" @click="handleEditSave">
          Save
        </button>
      </div>
    </div>
    <div v-if="editserviceMode || addserviceMode" class="servicesidepanel">
      <div>
        <div class="form-group">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Task
            <span class="error" v-if="!$v.taskDetails.task.required"
              >required</span
            ></label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            :disabled="
              taskDetails.task == 'Sub Total Labor' ||
              taskDetails.task == 'Project Management & Administration'
                ? true
                : false
            "
            v-model="taskDetails.task"
          />
        </div>
        <div class="form-group">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Notes</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="taskDetails.notes"
          />
        </div>
        <div class="form-group" v-if="addserviceMode">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Is Optional</label
          >
          <select
            v-model="taskDetails.isOptional"
            class="form-control"
            @change="selectOptional(taskDetails)"
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
        <div class="form-group" v-if="!taskDetails.hasFixedFee">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Rate/Hour<span
              class="error"
              v-if="!$v.taskDetails.hourlyRate.integer"
              >Enter Valid Rate</span
            ></label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="taskDetails.hourlyRate"
            @keyup="updateTaskPrice(taskDetails)"
          />
          <small class="form-text text-white">200.00</small>
        </div>
        <div class="form-group" v-if="!taskDetails.hasFixedFee">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Hours Estimate<span
              class="error"
              v-if="!$v.taskDetails.hours.integer"
              >Enter Valid Hours</span
            ></label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="taskDetails.hours"
            @keyup="updateTaskPrice(taskDetails)"
          />
          <small class="form-text text-white">e.g.,10</small>
        </div>
        <div class="form-group" v-if="!taskDetails.isOptional">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Task Price</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            :disabled="!taskDetails.hasFixedFee"
            v-model="taskDetails.taskPriceDisplayValue"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="form-group" v-if="taskDetails.isOptional">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Optional Task</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            :disabled="!taskDetails.hasFixedFee"
            v-model="taskDetails.optionalTaskPriceDisplayValue"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="form-group" v-if="false">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Total with Optional</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            disabled="true"
            v-model="taskDetails.fullTaskPriceDisplayValue"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="pl-1 pr-1">
          <button
            type="button"
            class="btn btn-dark"
            @click="
              editserviceMode = false;
              addserviceMode = false;
            "
          >
            Cancel
          </button>
          <button
            type="button"
            class="ml-2 btn btn-info"
            v-bind:disabled="isComplete"
            @click="handleService"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <div v-if="editTotalMode" class="estimatedlaborsidepanel">
      <div>
        <span class="normhead">Estimated Labor</span>
        <div class="form-group">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Task Price</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.estimatedLabor"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="form-group" v-if="totalDetails.hasOptionalTasks">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Optional Task</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.optionalEstimatedLabor"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="form-group" v-if="totalDetails.hasOptionalTasks">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Total with Optional</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.fullEstimatedLabor"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <span class="normhead">Travel Expenses At Cost</span>
        <div class="form-group">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Travel Expenses At Cost</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.travelExpense"
          />
        </div>
        <span class="normhead"> Estimated Labor Cost</span>
        <div class="form-group">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Task Price</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.totalEstimatedLabor"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="form-group" v-if="totalDetails.hasOptionalTasks">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Optional Task</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.optionalTotalEstimatedLabor"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="form-group" v-if="totalDetails.hasOptionalTasks">
          <label for="txtTitle" class="font-weight-bold text-white"
            >Total with Optional</label
          >
          <input
            type="text"
            class="form-control"
            id="txtTitle"
            v-model="totalDetails.fullTotalEstimatedLabor"
          />
          <small class="form-text text-white"
            >e.g.,{{ this.mainCurrencySymbol }}2,500.00</small
          >
        </div>
        <div class="pl-1 pr-1">
          <button
            type="button"
            class="btn btn-dark"
            @click="editTotalMode = false"
          >
            Cancel
          </button>
          <button
            type="button"
            class="ml-2 btn btn-info"
            @click="handleEditEstimatedLabour"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import uuidv1 from "uuid/v1";
import numToWords from "../utils/numToWords";
import services from "../services/index";
import Vue from "vue";
import {
  required,
  integer,
  minLength,
  helpers,
} from "vuelidate/lib/validators";
export default {
  name: "ReviewContent",
  beforeMount() {
    var that = this;
    that.$root.$emit("stage", 4);
    let servicesConfig = that.$store.getters.servicesConfig;
    this.isServiceconfig = servicesConfig.length ? true : false;
    if (this.isServiceconfig) {
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Fetching Service Tasks",
        message: "Fetching the tasks for the selected services",
      });
      /*
          1. Get the selected services
          2. 
      */
      let selectedLawfirm = that.$store.getters.selectedLawfirm;
      let selServices = that.$store.getters.selectedServices;
      let masterData = that.$store.getters.masterData;
      let incidentType = that.$store.getters.selectedIncidentType;
      let selectedTemplateConfig =
        that.$store.getters.selectedMasterTemplateConfig;

      for (let index = 0; index < servicesConfig.length; index++) {
        const element = servicesConfig[index];
        var selService = _.find(
          selServices,
          (selser) => selser.slug === element.serviceId
        );
        if (selService) {
          element.serviceOrder = selService.isOptional
            ? 999 + selService.serviceOrder
            : selService.serviceOrder;
          let serviceMasterRecord = _.find(
            masterData.services,
            (service) => service.slug === element.serviceId
          );
          let serviceTitle = serviceMasterRecord.title;
          var serviceOverwritesElement = _.find(
            serviceMasterRecord.Data,
            (dataElement) => {
              return dataElement.Key === "Overwrites";
            }
          );
          // let items=[];
          // _.each(selService.overView, (ov, index) => {
          //   items.push({
          //     description: ov,
          //   });
          // });
          var serviceOverviewElement = selService.overView;
          var titleOverwritesElement = _.find(
            selService.titleOverWrites,
            (to) => {
              return to.incidentTypeSlug === incidentType;
            }
          );

          let incidentTypeServiceDescription = serviceOverwritesElement
            ? serviceOverwritesElement.Value[incidentType]
              ? serviceOverwritesElement.Value[incidentType].description
              : null
            : null;
          let incidentTypeServiceTitle = titleOverwritesElement
            ? titleOverwritesElement.title
            : null;
          let incidentTypeServiceOverviews = serviceOverwritesElement
            ? serviceOverwritesElement.Value[incidentType]
              ? !serviceOverwritesElement.Value[incidentType].Disabled
                ? serviceOverwritesElement.Value[incidentType].ServiceOverview
                  ? serviceOverwritesElement.Value[incidentType].ServiceOverview
                      .Items
                  : null
                : null
              : null
            : null;
          let serviceOverview = incidentTypeServiceOverviews
            ? incidentTypeServiceOverviews
            : serviceOverviewElement
            ? serviceOverviewElement
            : [];
          // element.serviceTitle = element.ServiceTitle
          //   ? element.ServiceTitle
          //   : serviceTitle; //element.isOptional ? 'OPTIONAL - ' + serviceTitle : serviceTitle;
          //element.ServiceOverview = serviceOverview;
          element.ServiceOverview =
            selectedLawfirm == "lf-bak"
              ? incidentType == "it-bus-ema-com"
                ? selService.Slug == "svc-sec-val-mon-and-con"
                  ? []
                  : serviceOverview
                : serviceOverview
              : serviceOverview;
          element.configOVerviews = selectedTemplateConfig.serviceOverview
            ? selectedTemplateConfig.serviceOverview.items
              ? selectedTemplateConfig.serviceOverview.items.length
              : 0
            : 0;
          element.serviceTitle = incidentTypeServiceTitle
            ? incidentTypeServiceTitle
            : element.serviceTitle
            ? element.serviceTitle
            : serviceTitle;
          element.serviceDescription = element.serviceDescription
            ? element.serviceDescription
            : incidentTypeServiceDescription
            ? incidentTypeServiceDescription
            : serviceMasterRecord.description;
          /*All the different states of the service
            title Edit
            description Edit
            Task Add
        */
          element.serviceViewMode = true;
          element.taskAddMode = false;
          _.each(element.tasks, (task) => {
            /*
            All the different states of the task             
              Edit Task
              Delete Task
          */
            const taskDescription = task.originalDescription
              ? task.originalDescription
              : task.description;
            const taskOriginalDescription = task.originalDescription
              ? task.originalDescription
              : taskDescription;
            task.originalDescription = taskOriginalDescription;
            task.description = taskDescription;
            task.isActive = task.isActive;
            task.taskViewMode = true;
            let activeItems = [];
            _.each(element.scopes, (scope) => {
              const scopeDescription = scope.originalDescription
                ? scope.originalDescription
                : scope.description;
              const scopeOriginalDescription = scope.originalDescription
                ? scope.originalDescription
                : scopeDescription;
              scope.originalDescription = scopeOriginalDescription;
              scope.description = scopeDescription;
              if (element.hasSubTasks) {
                scope.shouldBeHidden = !scope.isActive;
                if (scope.isActive) {
                  activeItems.push(scope.title);
                }
              }
              _.each(scope.inputs, (scopeInput) => {
                scope.description = scope.description.replace(
                  "{" + scopeInput.slug + "}",
                  this.formatType(scopeInput.type) == "Dollar"
                    ? this.convertCurrency(scopeInput.defaultValue)
                    : scopeInput.defaultValue
                );

                task.description = task.description.replace(
                  "{" + scopeInput.slug + "}",
                  this.formatType(scopeInput.type) == "Dollar"
                    ? this.convertCurrency(scopeInput.defaultValue)
                    : scopeInput.defaultValue
                );
                //handled task inputs items
                if (task.items) {
                  _.each(task.items, (taskInputs) => {
                    let selectedSpec = _.filter(
                      scopeInput.inputs,
                      (speScope) => speScope.title == scopeInput.defaultValue
                    );
                    if (element.hasSubTasks) {
                      if (activeItems.includes(taskInputs.title)) {
                        taskInputs.isActive = true;
                      } else {
                        taskInputs.isActive = false;
                      }
                    }
                    _.each(taskInputs.items, (taskInputsItems) => {
                      taskInputsItems.description =
                        taskInputsItems.description.replace(
                          "{" + scopeInput.slug + "}",
                          scopeInput.type == "Dollar"
                            ? this.convertCurrency(scopeInput.defaultValue)
                            : scopeInput.defaultValue
                        );
                      taskInputsItems.description =
                        taskInputsItems.description.replace(
                          `{extracted(${scopeInput.slug})}`,
                          scopeInput.defaultValue * 1.5
                        );
                    });
                    // if (selectedSpec.length > 0) {
                    //   let selectedSpecInputs = selectedSpec[0].inputs;
                    //   let selecteddataType = _.filter(
                    //     selectedSpec[0].inputs,
                    //     (speInput) => speInput.title == "Data Type"
                    //   );

                    //   _.each(taskInputs.items, (speItem, specIndex) => {
                    //     taskInputs.items[specIndex].IsSelected = false;
                    //     if (
                    //       speItem.title ==
                    //       selectedSpec[0].title +
                    //         "-" +
                    //         selecteddataType[0].defaultValue
                    //     ) {
                    //       taskInputs.items[specIndex].IsSelected = true;
                    //       _.each(selectedSpecInputs, (selspcinput) => {
                    //         let val = "{" + selspcinput.slug + "}";
                    //         let valtxt = `{numtowords(${selspcinput.slug})}`;
                    //         let regex = new RegExp(val, "gi");
                    //         let regextxt = new RegExp(valtxt, "gi");
                    //         if (selspcinput.slug === "typeofemailbox") {
                    //           selspcinput.defaultValue =
                    //             selspcinput.defaultValue
                    //               .charAt(0)
                    //               .toUpperCase() +
                    //             selspcinput.defaultValue.slice(1);
                    //         }
                    //         speItem.description = speItem.description.replace(
                    //           regex,
                    //           selspcinput.defaultValue
                    //         );
                    //         speItem.description = speItem.description.replace(
                    //           `{extracted(${selspcinput.slug})}`,
                    //           selspcinput.defaultValue * 1.5
                    //         );
                    //         speItem.description = speItem.description.replace(
                    //           `{numtowords(${selspcinput.slug})}`,
                    //           numToWords(selspcinput.defaultValue).trim()
                    //         );
                    //         speItem.description =
                    //           speItem.description.charAt(0).toUpperCase() +
                    //           speItem.description.slice(1);
                    //       });
                    //     }
                    //   });
                    // }
                  });
                }
                if (
                  selService.slug == "svc-for-inv-sys" &&
                  scopeInput.defaultValue == 1 &&
                  scopeInput.slug == "scopedsystems"
                ) {
                  scope.description = scope.description
                    .replace(`up to `, ``)
                    .replace(new RegExp("\\b" + "systems" + "\\b"), `system`);
                  task.description = task.description
                    .replace(`up to `, ``)
                    .replace(new RegExp("\\b" + "systems" + "\\b"), `system`);
                }
                if (scopeInput.defaultValue == 1) {
                  task.description = task.description.replace(`(s)`, ``);
                }
                if (
                  task.description.indexOf(
                    `{numtowords(${scopeInput.slug})}`
                  ) != -1
                ) {
                  var scopeInputValueTextRepresentation = numToWords(
                    scopeInput.defaultValue
                  ).trim();
                  task.description = task.description.replace(
                    `{numtowords(${scopeInput.slug})}`,
                    scopeInputValueTextRepresentation
                  );
                  if (
                    element.serviceDescription.indexOf(
                      `{numtowords(${scopeInput.slug})}`
                    ) != -1
                  ) {
                    element.serviceDescription =
                      element.serviceDescription.replace(
                        `{numtowords(${scopeInput.slug})}`,
                        scopeInputValueTextRepresentation
                      );
                  }
                }
                element.serviceDescription = element.serviceDescription.replace(
                  "{" + scopeInput.slug + "}",
                  scopeInput.defaultValue
                );
                if (
                  scope.description.indexOf(
                    `{numtowords(${scopeInput.slug})}`
                  ) != -1
                ) {
                  var scopeInputValueTextRepresentation = numToWords(
                    scopeInput.defaultValue
                  ).trim();
                  scope.description = scope.description.replace(
                    `{numtowords(${scopeInput.slug})}`,
                    scopeInputValueTextRepresentation
                  );
                }
              });
            });
          });
          if (selectedTemplateConfig.serviceOverview) {
            element.DefaultOverviews = _.filter(
              selectedTemplateConfig.serviceOverview.items,
              (mr) => mr.isActive == true
            );
          } else {
            element.DefaultOverviews = {};
          }
          that.servicesConfig.push(element);
        }
      }
      that.servicesConfig = _.sortBy(
        that.servicesConfig,
        (config) => config.serviceOrder
      );
      if (
        (this.$store.getters.selectedIncidentType == "it-ran-eve" ||
          this.$store.getters.selectedIncidentType == "it-bus-ema-com" ||
          this.$store.getters.selectedIncidentType == "it-extortion") &&
        this.$store.getters.selectedCountry != "ctry-in-le" &&
        (that.$store.getters.selectedProject ||
          that.$store.getters.newClientRateCardData)
      ) {
        if (
          !that.$store.getters.rateCardsDetails ||
          that.$store.getters.newClientRateCardData
        ) {
          let sowData = {};
          let ratecardData = {};
          let servicesMasterRecord = that.$store.getters.masterData.services;
          let servicesData = [];
          let servicesSubData = [];
          _.each(this.servicesConfig, (service) => {
            let serviceData = {};
            let ratecardServiceData = {};
            if (!service.hasSubTasks) {
              ratecardServiceData.Title = service.isOptional
                ? "OPTIONAL - " + service.serviceTitle
                : service.serviceTitle;
              ratecardServiceData.IsOptional = service.isOptional;
              ratecardServiceData.Scopes = service.scopes;
              servicesSubData.push(Object.assign({}, ratecardServiceData));
            } else {
              _.each(service.scopes, (scope) => {
                if (!scope.shouldBeHidden && scope.isSubTaskScope) {
                  let scopes = [];
                  scopes.push(Object.assign({}, scope));
                  ratecardServiceData.Title = service.isOptional
                    ? "OPTIONAL - " + scope.title
                    : scope.title;
                  ratecardServiceData.IsOptional = service.isOptional;
                  ratecardServiceData.Scopes = scopes;
                  ratecardServiceData.serviceDescription = servicesSubData.push(
                    Object.assign({}, ratecardServiceData)
                  );
                }
              });
            }
            serviceData.Code = service.slug;
            serviceData.Slug = service.slug;
            serviceData.servicecode = service.serviceId;
            serviceData.serviceTitle = service.serviceTitle;
            serviceData.serviceDescription = service.serviceDescription;
            serviceData.isOptional = service.isOptional;
            serviceData.Tasks = service.tasks;
            serviceData.Scopes = service.scopes;
            serviceData.PreSections = service.preSections;
            serviceData.PostSections = service.postSections;
            serviceData.ServiceOverview = service.ServiceOverview;
            serviceData.HasSubTasks = service.hasSubTasks;
            servicesData.push(serviceData);
          });
          let scopes = _.map(servicesSubData, (serviceData) => {
            _.map(serviceData.Scopes, (serviceScope) => {
              return {
                Code: serviceScope.slug,
                Description: serviceScope.description,
                Inputs: serviceScope.inputs,
              };
            });
          });
          servicesSubData.Scopes = scopes;
          ratecardData.Services = servicesSubData;
          sowData.Services = _.map(servicesData, (serviceData) => {
            var serviceConfig = _.find(selServices, (selService) => {
              return selService.slug === serviceData.servicecode;
            }).serviceConfig;
            let serviceMasterRecord = _.find(servicesMasterRecord, (smr) => {
              return smr.slug === serviceData.servicecode;
            });
            let activeTasks = _.filter(serviceData.Tasks, (t) => t.isActive);
            let tasks = _.map(activeTasks, (serviceTask) => {
              let items = [];
              let activeitems = _.filter(serviceTask.items, (t) => t.isActive);
              if (activeitems && activeitems.length > 0) {
                items = _.map(activeitems, (serviceTaskItem) => {
                  let childitems = [];
                  if (
                    serviceTaskItem.items &&
                    serviceTaskItem.items.length > 0 &&
                    serviceData.servicecode != "svc-dat-bre-ana-pha-2" &&
                    serviceData.servicecode != "svc-dat-bre-ana-pha-1"
                  ) {
                    childitems = _.map(
                      serviceTaskItem.items,
                      (serviceTaskChildItem) => {
                        return {
                          Code: serviceTaskChildItem.slug,
                          Description: serviceTaskChildItem.description,
                          Title: serviceTaskChildItem.title,
                          Items: serviceTaskChildItem.items,
                        };
                      }
                    );
                  }
                  return {
                    Code: serviceTaskItem.slug,
                    Description: serviceTaskItem.description,
                    Title: serviceTaskItem.title,
                    Items:
                      serviceData.servicecode != "svc-dat-bre-ana-pha-2" &&
                      serviceData.servicecode != "svc-dat-bre-ana-pha-1"
                        ? serviceTaskItem.items
                        : _.filter(serviceTaskItem.items, (x) => x.IsSelected), // Need to test
                  };
                });
              }
              return {
                Code: serviceTask.slug,
                Description: serviceTask.description,
                Title: serviceTask.title,
                Items: items,
              };
            });
            let serviceOverview = serviceData.ServiceOverview;

            let preSections = [];
            if (serviceData.PreSections && serviceData.PreSections.length > 0) {
              preSections = _.map(serviceData.PreSections, (section) => {
                return {
                  Code: section.slug,
                  Description: section.description,
                  Title: section.title,
                };
              });
            }
            let postSections = [];
            if (
              serviceData.PostSections &&
              serviceData.PostSections.length > 0
            ) {
              postSections = _.map(serviceData.PostSections, (section) => {
                return {
                  Code: section.slug,
                  Description: section.description,
                  Title: section.title,
                };
              });
            }
            console.log(serviceData.Scopes);
            var shouldBeRenderedScopes = _.filter(
              serviceData.Scopes,
              (scope) => {
                var curScope = _.find(
                  serviceConfig.scopes,
                  (configScope) => configScope.slug === scope.slug
                );
                return !curScope.shouldBeHidden;
              }
            );
            console.log(shouldBeRenderedScopes);
            let scopes = _.map(shouldBeRenderedScopes, (serviceScope) => {
              return {
                Code: serviceScope.slug,
                Description: serviceScope.description,
                Inputs: serviceScope.inputs,
              };
            });
            let addnlScopes = _.filter(
              serviceData.AdditionalScopes,
              (scope) => scope.isActive
            );
            addnlScopes = _.map(addnlScopes, (serviceScope) => {
              return {
                Code: serviceScope.slug,
                Description: serviceScope.description,
              };
            });
            scopes = _.union(scopes, addnlScopes);
            let serviceOverviewClone = null;
            if (serviceOverview) {
              serviceOverviewClone = { ...serviceOverview };
            }
            return {
              Title: serviceData.isOptional
                ? "OPTIONAL - " + serviceData.serviceTitle
                : serviceData.serviceTitle,
              Code: serviceMasterRecord.slug,
              Description: serviceMasterRecord.description,
              isOptional: serviceData.isOptional,
              HasSubTasks: serviceData.hasSubTasks,
              ServiceOrder: serviceMasterRecord.order,
              //Phase: "Phase 1",
              ServiceOverview: serviceOverviewClone,
              Tasks: tasks,
              Scopes: scopes,
              PostSections: postSections,
              PreSections: preSections,
            };
          });
          if (that.$store.getters.selectedProject != null) {
            ratecardData.MavenlinkId = that.$store.getters.selectedProject.id;
            ratecardData.CurrencyType =
              that.$store.getters.selectedProject.currency;
            ratecardData.CurrencySymbol =
              that.$store.getters.selectedProject.currency_symbol;
            ratecardData.RateCardId = that.$store.getters.selectedProject
              .rate_card_id
              ? that.$store.getters.selectedProject.rate_card_id
              : 0;
            var carrierdetails = _.find(
              that.$store.getters.selectedProject.custom_field_values,
              (selser) => selser.custom_field_id === this.carrierId
            );
            ratecardData.Carrier = carrierdetails
              ? carrierdetails.display_value
              : "";
            ratecardData.SubOfferingType =
              that.$store.getters.selectedSubofferingType;
            ratecardData.IncidentType =
              that.$store.getters.selectedIncidentType;
            ratecardData.Country = this.$store.getters.selectedCountry;
          } else if (that.$store.getters.newClientRateCardData) {
            let currency = this.countryCurrency();
            ratecardData.CurrencySymbol = currency[0].Symbol;
            ratecardData.CurrencyType = currency[0].Code;
            ratecardData.RateCardId =
              that.$store.getters.newClientRateCardData.rateCardId;
            ratecardData.Carrier =
              that.$store.getters.newClientRateCardData.carrier;
            ratecardData.SubOfferingType =
              that.$store.getters.selectedSubofferingType;
            ratecardData.IncidentType =
              that.$store.getters.selectedIncidentType;
            ratecardData.Country = this.$store.getters.selectedCountry;
          }
          serviceProxy.serviceConfig
            .getmasterServiceConfig(
              this.$store.getters.token,
              that.$store.getters.selectedTemplateConfig.masterServiceConfig
            )
            .then((data) => {
              let servicesConfig = data.data.data;
              ratecardData.MasterServiceConfig = servicesConfig;
              this.$store.commit("setMasterServiceConfig", servicesConfig);
              serviceProxy.sow
                .getRateCardDetails(this.$store.getters.token, ratecardData)
                .then((data) => {
                  this.$root.$emit("progress");
                  var result = data.data.data;
                  this.rateCardDetails = result;
                  that.$root.$emit("done");
                  that.$root.$emit("toast", {
                    title: "Fetching RateCard Details",
                    message: "Fetching RateCard Details",
                  });
                })
                .catch((e) => {
                  that.$root.$emit("done");
                  that.$root.$emit("toast", {
                    title: "OOPS",
                    message: "Error Fetching RateCard Details",
                  });
                  this.errorMsg = "Error Fetching RateCard Details";
                });
            })
            .catch((e) => {
              console.log(e);
              that.$root.$emit("done");
            });
          //End Service Data
        } else {
          this.rateCardDetails = this.$store.getters.rateCardsDetails;
          that.$root.$emit("done");
        }
      } else {
        that.$root.$emit("done");
      }
    }
  },
  watch: {
    services: function (newservicesConfig, oldservicesConfig) {
      console.log("service changed");
    },
  },
  methods: {
    selectOptional: function (data) {
      this.taskDetails.isOptional = data.isOptional == "true" ? true : false;
      this.updateTaskPrice();
    },
    formatType: function (value) {
      let that = this;
      let type = _.filter(that.inputoptions, (mr) => mr.value === value);
      return (value = type.length ? type[0].text : value);
    },
    subofferingfilter(value) {
      let that = this;
      if (!value) {
        return "";
      }
      value = value.toString();
      let soffering = _.filter(
        that.$store.getters.masterData.subofferingTypes,
        (lm) => lm.slug === value
      );
      return soffering[0].title;
    },
    countryfilter(value) {
      let that = this;
      if (!value) {
        return "";
      }
      value = value.toString();
      let country = _.filter(
        that.$store.getters.masterData.countries,
        (lm) => lm.slug === value
      );
      return country[0].title;
    },
    convertCurrency(value) {
      let country = this.countryfilter(this.$store.getters.selectedCountry);
      return Vue.convertCurrency(value, country);
    },
    countryCurrency() {
      let country = this.countryfilter(this.$store.getters.selectedCountry);
      return Vue.countryCurrency(country);
    },
    handleOverviewEdit(overview) {
      this.editovMode = true;
      this.editItem.Overview = overview.description;
      this.editoverview = overview;
    },
    handleServiceEdit(service) {
      service.serviceViewMode = !service.serviceViewMode;
      this.editMode = true;
      this.editItem.title = service.serviceTitle;
      this.editItem.description = service.serviceDescription;
      this.editingService = service;
    },
    handleServiceTSEdit(service) {
      service.serviceViewMode = !service.serviceViewMode;
      this.edittsMode = true;
      this.editItem.title = service.serviceTitle;
      this.editItem.description = service.serviceDescription;
      this.editingService = service;
    },
    handlePostSectionsEdit(postSections, service) {
      service.serviceViewMode = !service.serviceViewMode;
      this.editpsMode = true;
      this.editpostSections.title = postSections.title;
      this.editpostSections.description = postSections.description;
      this.editingService = service;
      this.editingPostsections = postSections;
    },
    handlePreSectionsEdit(preSections, service) {
      service.serviceViewMode = !service.serviceViewMode;
      this.editprsMode = true;
      this.editpreSections.title = preSections.title;
      this.editpreSections.description = preSections.description;
      this.editingService = service;
      this.editingPresections = preSections;
    },
    handleAdd(service) {
      this.addMode = true;
      this.editItem.title = "";
      this.editItem.description = "";
      this.editingService = service;
    },
    handleAddOverview(service) {
      this.addovMode = true;
      this.editItem.Overview = "";
      this.editingService = service;
    },
    handleAddScope(service) {
      this.addscopeMode = true;
      this.editItem.title = "";
      this.editItem.description = "";
      this.editingService = service;
    },
    handleTaskEdit(task) {
      task.taskViewMode = !task.taskViewMode;
      this.editMode = true;
      this.editItem.title = task.title;
      this.editItem.description = task.description;
      this.editingTask = task;
    },
    handleTaskItemsEdit(subitem) {
      this.editMode = true;
      this.editItem.title = subitem.title;
      this.editItem.description = subitem.description;
      this.editingTask = subitem;
    },
    handleScopeEdit(scope) {
      this.editMode = true;
      this.editItem.title = scope.title;
      this.editItem.description = scope.description;
      this.editingScope = scope;
    },
    handleEditSave() {
      // Code Cleanning
      if (
        this.editMode ||
        this.editovMode ||
        this.edittsMode ||
        this.editpsMode ||
        this.editprsMode
      ) {
        if (this.editingService.serviceTitle && this.edittsMode) {
          this.editingService.serviceTitle = this.editItem.title;
          this.editingService.serviceDescription = this.editItem.description;
          this.editingService = {};
        }
        if (this.editingTask.title || this.editingTask.description) {
          this.editingTask.title = this.editItem.title;
          this.editingTask.description = this.editItem.description;
          this.editingTask = {};
        }
        if (this.editoverview.description) {
          this.editoverview.description = this.editItem.Overview;
        }
        if (this.editingScope.title || this.editingScope.description) {
          this.editingScope.title = this.editItem.title;
          this.editingScope.description = this.editItem.description;
          this.editingScope = {};
        }
        if (this.editpostSections.title || this.editpostSections.description) {
          this.editingPostsections.title = this.editpostSections.title;
          this.editingPostsections.description =
            this.editpostSections.description;
          this.editingPostsections = {};
        }
        if (this.editpreSections.title || this.editpreSections.description) {
          this.editingPresections.title = this.editpreSections.title;
          this.editingPresections.description =
            this.editpreSections.description;
          this.editingPresections = {};
        }
        this.editMode = false;
        this.editovMode = false;
        this.edittsMode = false;
        this.editpsMode = false;
        this.editprsMode = false;
      } else if (this.addovMode) {
        //scopes = _.union(scopes, addnlScopes);
        let that = this;
        let addindex = that.servicesConfig.length - 1;
        that.servicesConfig[addindex].ServiceOverview.Items.push({
          description: this.editItem.Overview,
          isActive: true,
          slug: uuidv1(),
          title: null,
          items: null,
        });
        this.addovMode = false;
      } else if (this.addscopeMode) {
        this.editingService.scopes.push({
          title: this.editItem.title,
          description: this.editItem.description,
          slug: uuidv1(),
          shouldBeHidden: false,
          isActive: true,
        });
        this.addscopeMode = false;
      } else {
        this.editingService.tasks.push({
          title: this.editItem.title,
          description: this.editItem.description,
          Slug: uuidv1(),
          isActive: true,
        });
        this.addMode = false;
      }
      this.editItem.title = "";
      this.editItem.description = "";
      this.editingService = {};
    },
    warningModal(modalmessage) {
      this.$bvModal.msgBoxOk(modalmessage, {
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    confirmDelete(data) {
      var item = data.item;
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure, Do you want to delete " + item.task + "?",
          {
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.rateCardDetails.rateCards = _.reject(
              this.rateCardDetails.rateCards,
              function (n) {
                return n.task == item.task;
              }
            );
            this.totalCalculations();
            let optionalCount = _.filter(
              this.rateCardDetails.rateCards,
              (x) => x.isOptional
            );
            if (optionalCount.length == 0) {
              this.rateCardDetails.hasOptionalTasks = false;
            } else {
              this.rateCardDetails.hasOptionalTasks = true;
            }
          }
        })
        .catch((err) => {});
    },
    addService() {
      this.addserviceMode = true;
      this.taskDetails = {
        fullTaskPriceDisplayValue: null,
        hourlyRate: null,
        hourlyRateDisplayValue: null,
        hours: null,
        hoursDisplayValue: null,
        isOptional: false,
        notes: null,
        optionalTaskPriceDisplayValue: null,
        task: null,
        taskPrice: null,
        taskPriceDisplayValue: null,
        isNewService: true,
      };
    },
    editService(data) {
      var item = data.item;
      this.editserviceMode = true;
      (this.taskDetails = {
        fullTaskPriceDisplayValue: item.fullTaskPriceDisplayValue,
        hourlyRate: item.hourlyRate,
        hourlyRateDisplayValue: item.hourlyRateDisplayValue,
        hours: item.hours,
        hoursDisplayValue: item.hoursDisplayValue,
        isOptional:
          this.rateCardDetails.hasOptionalTasks &&
          (item.task == "Sub Total Labor" ||
            item.task == "Project Management & Administration")
            ? true
            : item.isOptional,
        notes: item.notes,
        optionalTaskPriceDisplayValue: item.optionalTaskPriceDisplayValue,
        task: item.task,
        taskPrice: item.taskPrice,
        taskPriceDisplayValue: item.taskPriceDisplayValue,
        hasFixedFee: item.hours == "0" || item.hours == "" ? true : false,
        isNewService: item.isNewService,
      }),
        (this.currentRow = data.index);
      console.log(item);
    },
    handleService() {
      let trecord = _.filter(
        this.rateCardDetails.rateCards,
        (m) => m.task == this.taskDetails.task
      );

      if (this.editserviceMode) {
        if (this.taskDetails.hasFixedFee) {
          if (!this.taskDetails.isOptional) {
            this.taskDetails.taskPrice = parseFloat(
              this.taskDetails.taskPriceDisplayValue
                .replace(this.mainCurrencySymbol, "")
                .replace(/,/g, "")
            );
            this.taskDetails.fullTaskPriceDisplayValue =
              this.taskDetails.taskPriceDisplayValue;
          } else {
            this.taskDetails.taskPrice = parseFloat(
              this.taskDetails.optionalTaskPriceDisplayValue
                .replace(this.mainCurrencySymbol, "")
                .replace(/,/g, "")
            );
            this.taskDetails.fullTaskPriceDisplayValue =
              this.taskDetails.optionalTaskPriceDisplayValue;
          }
        }
        let index = this.rateCardDetails.rateCards.findIndex(
          (x) => x.task == this.taskDetails.task
        );
        if (index == this.currentRow || index == -1) {
          if (!this.taskDetails.isOptional) {
            this.taskDetails.optionalTaskPriceDisplayValue = "";
          }
          this.rateCardDetails.rateCards.splice(
            this.currentRow,
            1,
            this.taskDetails
          );
          let optionalCount = _.filter(
            this.rateCardDetails.rateCards,
            (x) => x.isOptional
          );
          if (optionalCount.length == 0) {
            this.rateCardDetails.hasOptionalTasks = false;
          } else {
            this.rateCardDetails.hasOptionalTasks = true;
          }
          this.editserviceMode = false;
        } else {
          this.modalmessage = "Task with this title already exists";
          this.warningModal(this.modalmessage);
        }
        this.totalCalculations();
      } else if (this.addserviceMode) {
        if (trecord.length == 0) {
          let setindex = this.rateCardDetails.rateCards.findIndex(
            (x) => x.task === "Sub Total Labor"
          );
          this.rateCardDetails.rateCards.splice(setindex, 0, this.taskDetails);
          this.addserviceMode = false;
        } else {
          this.modalmessage = "Task with this title already exists";
          this.warningModal(this.modalmessage);
        }
        let optionalCount = _.filter(
          this.rateCardDetails.rateCards,
          (x) => x.isOptional
        );
        if (optionalCount.length == 0) {
          this.rateCardDetails.hasOptionalTasks = false;
        } else {
          this.rateCardDetails.hasOptionalTasks = true;
        }
        this.totalCalculations();
      }
    },
    editEstimatedLabour(data) {
      this.editTotalMode = true;
      this.totalDetails = {
        defaultRate: data.defaultRate,
        estimatedLabor: data.estimatedLabor,
        fullEstimatedLabor: data.fullEstimatedLabor,
        fullTotalEstimatedLabor: data.fullTotalEstimatedLabor,
        hasOptionalTasks: data.hasOptionalTasks,
        optionalEstimatedLabor: data.optionalEstimatedLabor,
        optionalTotalEstimatedLabor: data.optionalTotalEstimatedLabor,
        rateCards: data.rateCards,
        totalEstimatedLabor: data.totalEstimatedLabor,
        travelExpense: data.travelExpense,
      };
    },
    handleEditEstimatedLabour() {
      this.rateCardDetails = this.totalDetails;
      this.editTotalMode = false;
    },
    updateTaskPrice() {
      if (!this.taskDetails.isOptional) {
        this.taskDetails.taskPrice =
          this.taskDetails.hours * this.taskDetails.hourlyRate;
        this.taskDetails.taskPriceDisplayValue =
          this.taskDetails.fullTaskPriceDisplayValue =
            this.mainCurrencySymbol +
            "" +
            this.convertCurrency(
              this.mathRound(
                this.taskDetails.hours * this.taskDetails.hourlyRate
              )
            );
        this.taskDetails.hoursDisplayValue = this.taskDetails.hours;
        this.taskDetails.hourlyRateDisplayValue =
          this.mainCurrencySymbol +
          "" +
          this.convertCurrency(this.mathRound(this.taskDetails.hourlyRate));
      } else {
        this.taskDetails.optionalTaskPriceDisplayValue =
          this.taskDetails.fullTaskPriceDisplayValue =
            this.mainCurrencySymbol +
            "" +
            this.convertCurrency(
              this.mathRound(
                this.taskDetails.hours * this.taskDetails.hourlyRate
              )
            );
        this.taskDetails.hoursDisplayValue = this.taskDetails.hours;
        this.taskDetails.hourlyRateDisplayValue =
          this.mainCurrencySymbol +
          "" +
          this.convertCurrency(this.mathRound(this.taskDetails.hourlyRate));
      }
    },
    handlehasOptional() {
      this.editTotalMode = false;
      this.editserviceMode = false;
      this.addserviceMode = false;
    },
    mathRound(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    totalCalculations() {
      let subTotal = _.filter(
        this.rateCardDetails.rateCards,
        (rc) => rc.task == "Sub Total Labor"
      );
      let mainTotal = _.filter(
        this.rateCardDetails.rateCards,
        (rc) => rc.task != "Sub Total Labor"
      );
      let currencySymbol = this.mainCurrencySymbol;
      let totalOfAll = _.reject(this.rateCardDetails.rateCards, function (n) {
        return (
          n.task == "Sub Total Labor" ||
          n.task == "Project Management & Administration"
        );
      });
      if (subTotal.length > 0) {
        subTotal[0].fullTaskPriceDisplayValue =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              _.sumBy(totalOfAll, function (sm) {
                return parseFloat(
                  sm.fullTaskPriceDisplayValue
                    .replace(currencySymbol, "")
                    .replace(/,/g, "")
                );
              })
            )
          );
        let totalOfNotOptional = _.reject(
          this.rateCardDetails.rateCards,
          function (n) {
            return (
              n.task == "Sub Total Labor" ||
              n.task == "Project Management & Administration" ||
              n.isOptional
            );
          }
        );
        subTotal[0].taskPriceDisplayValue =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              _.sumBy(totalOfNotOptional, function (sm) {
                return sm.taskPrice;
              })
            )
          );
        let totalOfOptional = _.reject(
          this.rateCardDetails.rateCards,
          function (n) {
            return (
              n.task == "Sub Total Labor" ||
              n.task == "Project Management & Administration" ||
              !n.isOptional
            );
          }
        );
        subTotal[0].optionalTaskPriceDisplayValue =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              _.sumBy(totalOfOptional, function (sm) {
                return parseFloat(
                  sm.optionalTaskPriceDisplayValue
                    .replace(currencySymbol, "")
                    .replace(/,/g, "")
                );
              })
            )
          );
      }
      if (
        this.$store.getters.masterServiceConfig.isProjectManagementPercentage
      ) {
        let proManAdmin = _.filter(
          this.rateCardDetails.rateCards,
          (rc) => rc.task == "Project Management & Administration"
        );
        proManAdmin[0].taskPriceDisplayValue =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              0.07 *
                parseFloat(
                  _.sumBy(totalOfAll, function (sm) {
                    return parseFloat(
                      sm.taskPriceDisplayValue
                        ? sm.taskPriceDisplayValue
                            .replace(currencySymbol, "")
                            .replace(/,/g, "")
                        : "0"
                    );
                  })
                )
            )
          );
        proManAdmin[0].fullTaskPriceDisplayValue =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              0.07 *
                parseFloat(
                  _.sumBy(totalOfAll, function (sm) {
                    return parseFloat(
                      sm.fullTaskPriceDisplayValue
                        ? sm.fullTaskPriceDisplayValue
                            .replace(currencySymbol, "")
                            .replace(/,/g, "")
                        : "0"
                    );
                  })
                )
            )
          );
        proManAdmin[0].optionalTaskPriceDisplayValue =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              0.07 *
                parseFloat(
                  _.sumBy(totalOfAll, function (sm) {
                    return parseFloat(
                      sm.optionalTaskPriceDisplayValue
                        ? sm.optionalTaskPriceDisplayValue
                            .replace(currencySymbol, "")
                            .replace(/,/g, "")
                        : "0"
                    );
                  })
                )
            )
          );
      }
      let totalOfEstimateLaborNotOptional = _.filter(
        this.rateCardDetails.rateCards,
        function (n) {
          return (
            n.task == "Sub Total Labor" ||
            n.task == "Project Management & Administration"
          );
        }
      );
      this.rateCardDetails.estimatedLabor =
        this.rateCardDetails.totalEstimatedLabor =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              _.sumBy(mainTotal, function (sm) {
                return parseFloat(
                  sm.taskPriceDisplayValue
                    ? sm.taskPriceDisplayValue
                        .replace(currencySymbol, "")
                        .replace(/,/g, "")
                    : "0"
                );
              })
            )
          );
      this.rateCardDetails.optionalEstimatedLabor =
        this.rateCardDetails.optionalTotalEstimatedLabor =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              _.sumBy(mainTotal, function (sm) {
                return parseFloat(
                  sm.optionalTaskPriceDisplayValue
                    ? sm.optionalTaskPriceDisplayValue
                        .replace(currencySymbol, "")
                        .replace(/,/g, "")
                    : "0"
                );
              })
            )
          );
      this.rateCardDetails.fullEstimatedLabor =
        this.rateCardDetails.fullTotalEstimatedLabor =
          currencySymbol +
          "" +
          this.convertCurrency(
            this.mathRound(
              _.sumBy(mainTotal, function (sm) {
                return parseFloat(
                  sm.fullTaskPriceDisplayValue
                    ? sm.fullTaskPriceDisplayValue
                        .replace(currencySymbol, "")
                        .replace(/,/g, "")
                    : "0"
                );
              })
            )
          );
    },
    goback: function (oEvent) {
      this.$store.commit("setrateCardsDetails", this.rateCardDetails);
      this.$router.go(-1);
    },
    gonext: function (oEvent) {
      // that.$root.$emit("toast", {
      //   title: "TODO",
      //   message: "SoW Generation To Be Implement"
      // });
      let servicesData = [];
      _.each(this.servicesConfig, (service) => {
        let serviceData = {};
        serviceData.Code = service.slug;
        serviceData.Slug = service.slug;
        serviceData.servicecode = service.serviceId;
        serviceData.serviceTitle = service.serviceTitle;
        serviceData.serviceDescription = service.serviceDescription;
        serviceData.isOptional = service.isOptional;
        serviceData.Tasks = service.tasks;
        serviceData.Scopes = service.scopes;
        serviceData.PreSections = service.preSections;
        serviceData.PostSections = service.postSections;
        serviceData.ServiceOverview = service.ServiceOverview;
        servicesData.push(serviceData);
      });
      this.$store.commit("servicedatatasks", servicesData);
      this.$store.commit("setrateCardsDetails", this.rateCardDetails);
      this.$router.push({ path: "generate-sow" });
    },
  },
  computed: {
    isComplete() {
      if (
        this.$v.taskDetails.task.$invalid ||
        this.$v.taskDetails.hours.$invalid ||
        this.$v.taskDetails.hourlyRate.$invalid ||
        this.taskDetails.isOptional
          ? this.$v.taskDetails.optionalTaskPriceDisplayValue.$invalid
          : this.$v.taskDetails.taskPriceDisplayValue.$invalid
      ) {
        return true;
      }
    },
    notnextable() {
      return false;
    },
  },
  data() {
    return {
      carrierId: parseInt(process.env.VUE_APP_carrierId),
      mainCurrencySymbol: this.$store.getters.selectedProject
        ? this.$store.getters.selectedProject.currency_symbol
          ? this.$store.getters.selectedProject.currency_symbol
          : this.countryCurrency()[0].Symbol
        : this.countryCurrency()[0].Symbol,
      modalmessage: null,
      fields: [
        {
          key: "task",
          sortable: false,
          thClass: "thcust",
        },
        {
          key: "notes",
          sortable: false,
          thClass: "thcust",
        },
        {
          key: "hourlyRateDisplayValue",
          label: "Rate/Hour",
          thClass: "thcust",
        },
        {
          key: "hoursDisplayValue",
          label: "Hours Estimate",
          thClass: "thcust",
        },
        {
          key: "taskPriceDisplayValue",
          thClass: "thcust",
          label: "Task Price",
        },
        {
          key: "actions",
          label: "Actions",
          thClass: "thcust actionswidth",
          tdClass: " tbcol actionswidth tdact",
        },
      ],
      optionaltaskfields: [
        {
          key: "task",
          sortable: false,
          thClass: "thcust",
        },
        {
          key: "notes",
          sortable: false,
          thClass: "thcust",
        },
        {
          key: "hourlyRateDisplayValue",
          label: "Rate/Hour",
          thClass: "thcust",
        },
        {
          key: "hoursDisplayValue",
          label: "Hours Estimate",
          thClass: "thcust",
        },
        {
          key: "taskPriceDisplayValue",
          label: "Task Price",
          thClass: "thcust",
        },
        {
          key: "optionalTaskPriceDisplayValue",
          label: "Optional Task",
          thClass: "thcust",
        },
        {
          key: "fullTaskPriceDisplayValue",
          label: "Total with Optional",
          thClass: "thcust",
        },
        {
          key: "actions",
          label: "Actions",
          thClass: "thcust actionswidth",
          tdClass: " tbcol actionswidth tdact",
        },
      ],
      rateCardDetails: null,
      taskDetails: {
        fullTaskPriceDisplayValue: null,
        hourlyRate: 0,
        hourlyRateDisplayValue: null,
        hours: 0,
        hoursDisplayValue: null,
        isOptional: false,
        notes: null,
        optionalTaskPriceDisplayValue: null,
        task: null,
        taskPrice: 0,
        taskPriceDisplayValue: null,
        isNewService: false,
        hours: false,
      },
      totalDetails: {
        defaultRate: null,
        estimatedLabor: null,
        fullEstimatedLabor: null,
        fullTotalEstimatedLabor: null,
        hasOptionalTasks: null,
        optionalEstimatedLabor: null,
        optionalTotalEstimatedLabor: null,
        rateCards: null,
        totalEstimatedLabor: null,
        travelExpense: null,
      },
      inputoptions: [
        { value: 0, text: "Dollar" },
        { value: 1, text: "Hour" },
        { value: 2, text: "Number" },
        { value: 3, text: "Text" },
        { value: 4, text: "Select" },
      ],
      isServiceconfig: false,
      selectedSubType: this.$store.getters.selectedSubofferingType,
      servicesConfig: [],
      editMode: false,
      addMode: false,
      addovMode: false,
      addscopeMode: false,
      editovMode: false,
      edittsMode: false,
      editpsMode: false,
      editprsMode: false,
      editingService: {},
      editingPostsections: {},
      editingPresections: {},
      editingTask: {},
      editingScope: {},
      editoverview: {},
      editItem: {
        title: "",
        description: "",
      },
      editpostSections: {
        title: "",
        description: "",
      },
      editpreSections: {
        title: "",
        description: "",
      },
      editserviceMode: false,
      addserviceMode: false,
      editTotalMode: false,
      currentRow: null,
      errorMsg: null,
    };
  },
  validations: {
    taskDetails: {
      required,
      task: {
        required,
      },
      taskPriceDisplayValue: {
        required,
      },
      optionalTaskPriceDisplayValue: {
        required,
      },
      hours: {
        integer,
      },
      hourlyRate: {
        integer,
      },
    },
  },
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
/* ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */
a {
  color: #42b983;
}
label {
  font-size: 13px !important;
}
.sidepanel,
.servicesidepanel,
.estimatedlaborsidepanel {
  height: 100%;
  position: fixed;
  z-index: 101;
  top: 50px;
  right: 0;
  border-left: 1px solid #17a2b8;
  border-top: 1px solid #17a2b8;
  background-color: #686464;
  overflow-x: hidden;
  padding-top: 5px;
  padding-left: 5px;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5;
  -ms-transition: 0.5;
  transition: 0.5s;
  width: 45%;
  margin-top: 10px;
}
.sidepanel > div,
.servicesidepanel > div,
.estimatedlaborsidepanel > div {
  overflow-x: hidden;
  /* position: fixed; */
  height: 87%;
  width: 100%;
  overflow-y: auto;
}
.normhead {
  font-size: 14px;
  text-decoration: underline;
  color: white;
  font-weight: bold;
}
</style>


